import { defineNuxtPlugin } from '#app/nuxt';

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.hook('vue:error', (error, instance, info) => {
		// TODO error reporting
		console.error(error, instance, info);
	});
});
